<!-- src/components/CustomerServiceDialog.vue -->
<template>
  <el-dialog
    title="客户服务"
    :visible.sync="_cstomerDialogVisible"
    :before-close="handleClose"
    custom-class="customer-service-dialog"
    v-if="shouldRender"
  >
    <CustomerServiceContent
      v-if="_cstomerDialogVisible"
      :key="contentKey"
      @close="handleContentClose"
    />
  </el-dialog>
</template>

<script>
import CustomerServiceContent from './components/CustomerServiceContent.vue';

export default {
  name: 'CustomerServiceDialog',
  components: {
    CustomerServiceContent,
  },
  props: {
    cstomerDialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      shouldRender: true,
      contentKey: 0,
    };
  },
  methods: {
    handleClose(done) {
      this.$confirm('关闭窗口将结束本次对话，确定要关闭吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass:'confStyle'
      })
        .then(() => {
          this.$emit('update:cstomerDialogVisible', false);
          done();
        })
        .catch(() => {});
    },
    handleContentClose() {
      this.$emit('update:cstomerDialogVisible', false);
    },
    forceRerender() {
      // 通过改变key来强制重新创建子组件
      this.contentKey += 1;
    },
  },
  watch: {
    cstomerDialogVisible(newVal) {
      if (newVal) {
        this.forceRerender();
      }
    },
  },
  computed: {
    _cstomerDialogVisible: {
      get() {
        return this.cstomerDialogVisible;
      },
      set(val) {
        this.$emit('update:cstomerDialogVisible', val);
      },
    },
  },
};
</script>

<style lang="less" scoped>
/* 对话框样式覆盖 */
/deep/ .customer-service-dialog {
  width: 35%;
  .el-dialog__body {
    padding: 20px;
  }
}
@media screen and (max-width: 768px) {
  /deep/ .customer-service-dialog {
    width:90% !important;
    padding: 10px;
    height: 460px;
    .message-container{
      min-height:200px
    }
  }
}
</style>
<style>

@media screen and (max-width: 768px) {
  .confStyle{
    width:90% !important;
  }
}
</style>
